export const LayerStatusType = Object.freeze({
  PROGRESS: 'progress',
  INCIDENT: 'incident',
});
